import { Injectable } from '@angular/core';
import type { AuthToken } from './auth.model';

const TOKEN_KEY = 'iam_auth_token';

@Injectable({ providedIn: 'root' })
export class AuthTokenStorage {
  getToken(): AuthToken | null {
    const stored = localStorage.getItem(TOKEN_KEY);
    if (!stored) return null;
    try {
      return JSON.parse(stored);
    } catch {
      return null;
    }
  }

  setToken(token: AuthToken): void {
    localStorage.setItem(TOKEN_KEY, JSON.stringify(token));
  }

  clearToken(): void {
    localStorage.removeItem(TOKEN_KEY);
  }

  getAccessToken(): string | null {
    const token = this.getToken();
    return token?.accessToken ?? null;
  }

  getRefreshToken(): string | null {
    const token = this.getToken();
    return token?.refreshToken ?? null;
  }

  isTokenExpired(token?: AuthToken): boolean {
    const tk = token ?? this.getToken();
    if (!tk) return true;
    return Date.now() >= tk.expiresAt;
  }

  clearAll(): void {
    this.clearToken();
    localStorage.removeItem('iam_auth_user');
  }
}
